__turbopack_context__.v({
  "childrenWrapper": "PageHeader-module__HZea0q__childrenWrapper",
  "container": "PageHeader-module__HZea0q__container",
  "headerWrapper": "PageHeader-module__HZea0q__headerWrapper",
  "title": "PageHeader-module__HZea0q__title",
  "titleRow": "PageHeader-module__HZea0q__titleRow",
});
